import { coreApi } from "../../app/core-api";
import { PagedResult, PagedSearchFilter } from "../../app/types";
import { CustomerCreateDto, CustomerListItem, CustomersFilter } from "./customers.types";

const controller = "customers";

export const customersApi = {
    searchCustomers,
    getCustomer,
    createCustomer,
    updateCustomer,
    deleteCustomer,
};

function searchCustomers(filter: PagedSearchFilter<CustomersFilter>) {
    return coreApi.get<PagedResult<CustomerListItem>>(`${controller}`, {
        ...filter.filter,
        ...filter.pagination,
    });
}

function getCustomer(id: string) {
    return coreApi.get<CustomerListItem>(`${controller}/${id}`);
}

function createCustomer(data: CustomerCreateDto) {
    return coreApi.post<{ id: string }>(controller, data);
}

function updateCustomer(id: string, data: CustomerCreateDto) {
    return coreApi.put<{ id: string }>(`${controller}/${id}`, data);
}

function deleteCustomer(id: string) {
    return coreApi.remove(`${controller}/${id}`);
}
